// Rich menu input types and their configurations
export const RICHMENU_INPUT_OPTIONS = [
	{ value: "message", label: "メッセージ" },
	{ value: "uri", label: "URI" },
	{ value: "telephone", label: "電話" },
	{ value: "customUriMembership", label: "会員証リンク" },
];

export const RICHMENU_ACTION_VALUE_MAP = {
	message: "text",
	uri: "uri",
	telephone: "uri",
	customUriMembership: "uri",
} as const;

export const RICHMENU_ACTION_PLACEHOLDER = {
	message: "メッセージ内容",
	uri: "URL",
	telephone: "電話番号",
	customUriMembership: "会員証URL",
} as const;

export const MAX_RICHMENU_TABS = 3;

export const DEFAULT_RICHMENU_SIZE = {
	width: 1200,
	height: 405,
} as const;

export const DEFAULT_RICHMENU_DATA = {
	name: "Rich Menu",
	chatBarText: "メニュー",
	templateType: "",
	areas: [] as any[],
	size: DEFAULT_RICHMENU_SIZE,
};
